<template>
  <div aria-hidden="true">
    <div
      v-for="n in lines"
      :key="n"
      class="skeleton"
      :style="{
        width: n === lines && lines > 1 ? lastLineWidth : width,
        height,
        marginBottom: lines > 1 && n < lines ? '8px' : undefined,
      }"
    />
  </div>
</template>

<script setup lang="ts">
/**
 * Loading placeholder (wraps the global .skeleton class) so call sites stop
 * inline-sizing skeletons ad hoc. Multi-line mode shortens the last line the
 * way real text falls.
 */
withDefaults(
  defineProps<{
    width?: string
    height?: string
    lines?: number
    lastLineWidth?: string
  }>(),
  { width: "100%", height: "16px", lines: 1, lastLineWidth: "60%" },
)
</script>
